// MerchantDataColumns.js
import React from "react";
import { decimalTo } from '../../utils/utils';

// Safely convert exponential or number to decimal string
function convertExponentialToDecimal(value) {
  if (typeof value !== "number" || isNaN(value)) return "0.00";
  const str = value.toString();
  const parts = str.split(/[eE]/);
  return decimalTo(parts[0]).toFixed(2);
}

// Safely format any number to 2 decimal places
function safeToFixed(num) {
  return typeof num === "number" && !isNaN(num) ? decimalTo(num).toFixed(2) : "0.00";
}

export const MerchantDataColumns = (handleRoute,region) => [
  {
    name: "S.No",
    cell: (row, index) => (
      <>
        <input type="hidden" value={row.merchentId} />
        <span>{index + 1}</span>
      </>
    ),
    sortable: false,
  },
  {
    name: "Merchant",
    selector: (row) => row.merchentName,
    cell: (row) => (
      <span onClick={() => handleRoute(row)}>
        <span className="add-ellip wethislink">{row.merchentName}</span>
      </span>
    ),
  },
  {
    name: "Total Order Quantity",
    selector: (row) => row.totalSaleQuantity,
  },
  {
    name: "Total Order Amount",
    selector: (row) => row.totalSaleAmount,
    cell: (row) => (
      <span className="add-ellip">{safeToFixed(row.totalSaleAmount)}</span>
    ),
  },
  {
    name: "Total Margin",
    selector: (row) => row.totalSaleMargin,
    cell: (row) => (
      <span className="add-ellip">{safeToFixed(row.totalSaleMargin)}</span>
    ),
  },
  {
    name: `Total Net Amount${region?.currency ? ` (${region.currency})` : ''}`,
    selector: (row) => row.totalSaleNetAmount,
    cell: (row) => (
      <span className="add-ellip">{safeToFixed(row.totalSaleNetAmount)}</span>
    ),
  },
  {
    name: "Remaining Balance",
    selector: (row) => row.balanceAmount,
    cell: (row) => (
      <span>{convertExponentialToDecimal(row.balanceAmount)}</span>
    ),
  },
];
